import baseUrlPath from "./baseUrlPath";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const QuestionApi = createApi({
    reducerPath: "questionApi",
    baseQuery:fetchBaseQuery({
        baseUrl:baseUrlPath.test+"/questions/"
    }),
    tagTypes:["questions"],
    endpoints:(builder) => ({
        createQuestion:builder.mutation({
            query:(dataQuestion) =>({
                url:"add-question",
                method:"POST",
                // headers:{
                //     "content-type":"multipart/form-data",
                // },
                body:dataQuestion,
            }),
            invalidatesTags:["questions"]
        }),

          updateQuestion:builder.mutation({
            query:(dataQuestion) =>({
                url:"update-question",
                method:"PUT",
                headers:{
                    "content-type":"application/json",
                },
                body:dataQuestion,
            }),
            invalidatesTags:["questions"]
        }),
         deleteQuestion:builder.mutation({
            query:(id) =>({
                url:"delete-question",
                method:"delete",
                params:{
                   id
                },
            }),
            invalidatesTags:["questions"]
        }),

        getQuestionsList: builder.query({
            query: ({searchString, pageSize, pageNumber, categoryId, subCategoryId, level}) => ({
                  url: "get-all-questions",
                  params: {
            ...(searchString && { searchString }),
            ...(pageNumber && { pageNumber }),
            ...(pageSize && { pageSize }),
            ...(categoryId && { categoryId }),
            ...(subCategoryId && { subCategoryId }),
            ...(level && { level }),
         }, 
            }),
            providesTags: ["questions"],
        }),
        getDropdownList: builder.query({
            query: () => ({
                  url: "get-dropdowns",
            }),
            providesTags: ["questions"],
        }),
              
        
    }),
});

export const {
useGetDropdownListQuery,
useCreateQuestionMutation,
useGetQuestionsListQuery,
useUpdateQuestionMutation,
useDeleteQuestionMutation,
} = QuestionApi;